import React from "react";
import {
  FaServer,
  FaBroadcastTower,
  FaBuilding,
  FaHospitalAlt,
  FaIndustry,
  FaHome,
  FaGem,
  FaUtensils,
  FaUniversity,
  FaDatabase,
  FaTshirt,
  FaSnowflake,
  FaPizzaSlice,
  FaBoxes,
} from "react-icons/fa";
import { MdMedicalServices } from "react-icons/md";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";

const items = [
  { title: "Server, Panel & UPS rooms", Icon: FaServer },
  { title: "News studio rooms", Icon: FaBroadcastTower },
  { title: "Offices & Showrooms", Icon: FaBuilding },
  { title: "Hospital & Hotels Projects", Icon: FaHospitalAlt },
  { title: "MRI & Operation Theatre", Icon: MdMedicalServices },
  { title: "Industrial Air conditioning", Icon: FaIndustry },
  { title: "Residential Villa", Icon: FaHome },
  { title: "Jewellery Showrooms", Icon: FaGem },
  { title: "Banquet Halls & Restaurants", Icon: FaUtensils },
  { title: "Banking sector", Icon: FaUniversity },
  { title: "Cement Plants & Power plants", Icon: FaBoxes },
  { title: "Crushers, Data Center etc", Icon: FaDatabase },
  { title: "Textile & printing Industry", Icon: FaTshirt },
  { title: "Cold Rooms / PUF Shades", Icon: FaSnowflake },
  { title: "Food Industries", Icon: FaPizzaSlice },
];

const ApplicationsSlider = () => {
  return (
    <section className="container my-3">
      <h1 className="text-center mb-4 fw-bold" style={{ color: '#079000'}}>
        Applications & Sectors
      </h1>

      <Swiper
        modules={[Autoplay]}
        spaceBetween={20}
        slidesPerView={1}
        autoplay={{ delay: 2000, disableOnInteraction: false }}
        loop={true}
        breakpoints={{
          576: { slidesPerView: 2 }, // mobile landscape
          768: { slidesPerView: 3 }, // tablet
          1024: { slidesPerView: 4 }, // desktop
        }}
      >
        {items.map((it, index) => {
          const Icon = it.Icon;
          return (
            <SwiperSlide key={index}>
              <div className="card shadow-sm text-center p-4 h-100">
                <div className="application-border-style">
                  <Icon className="mb-3 icon-font" style={{ color: '#079000' }} size={40} />
                </div>
                <h6 className="fw-semibold">{it.title}</h6>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default ApplicationsSlider;
